import dayjs from 'dayjs';

export const passedTime = (startDate, endDate = dayjs()) => {
  const days = endDate.diff(startDate, 'days');
  const hours = endDate.diff(startDate, 'hours') - days * 24;
  const diffMinutes = endDate.diff(startDate, 'minutes');
  const minutes = diffMinutes - days * 24 * 60 - hours * 60;
  let time;

  if (days > 0) {
    time = `${days}d, ${hours}h${minutes}`;
  } else if (hours > 0) {
    time = `${hours}h${minutes}`;
  } else {
    time = `${minutes}m`;
  }

  return { days, hours, minutes, time, diffMinutes };
}
